export const itemsLabel = "QFnkfe";
export const itemsTooltip = "jNqFW";
export const unreadLabel = "F5R0eb";
export const unreadTooltip = "ykGOcd";
export const statusBarZoom = "stGMcb";
export const statusBarZoomIn = "xJEFYb";
export const statusBarZoomOut = "eHCAg";
export const statusBarZoomLevel = "_kgB1";
export default {itemsLabel,itemsTooltip,unreadLabel,unreadTooltip,statusBarZoom,statusBarZoomIn,statusBarZoomOut,statusBarZoomLevel};